<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h2>Load Details</h2>
      </div>
      <div class="ibox-content">
        <ul class="list-detail list-detail-load-breakdown">
          <admin-load v-for="(load, index) in loadsOrderedByLoadingDate" :key="load.id" :load="load" :index="index"></admin-load>

          <li v-if="haveNoLoads" class="text-center text-muted">
            There are no loads.
          </li>
        </ul>
      </div>
      <div class="ibox-footer">

        <div class="row">
          <div class="col-sm-5">
            <a class="btn btn-sm btn-info" data-toggle="modal" data-target=".modal-last-load" v-if="canFinaliseJob">Finalise Job</a>

            <ladda-button
              v-if="canUnfinaliseJob"
              :on-click="handleUnfinaliseJob"
              size="small"
              type="warning"
            >
              Unfinalise
            </ladda-button>
          </div>
          <div class="col-sm-7">
            <p class="assigned">Assigned: {{ loadSize }} of {{ jobSize }} tonnes. ({{ loadPercentage }}%)</p>
          </div>
        </div>
      </div>
    </div>

    <template v-if="jobIsEditable">
      <load-planner></load-planner>

      <last-load-modal v-if="canFinaliseJob"></last-load-modal>
    </template>

    <load-check-modal v-if="haveLoadWithWeighbridge"></load-check-modal>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { assignedTonnageHelpers } from 'mixins/loads'
  import { jobHelpers } from 'mixins/jobs'
  import { orderBy } from 'lodash'
  import LoadPlanner from './LoadPlanner'
  import AdminLoad from './AdminLoad'
  import LastLoadModal from './LastLoadModal'
  import LoadCheckModal from 'components/loads/LoadCheckModal'
  import moment from 'moment'
  import { LaddaButton } from 'components/forms'

  export default {
    mixins: [assignedTonnageHelpers, jobHelpers],

    components: {
      LoadPlanner,
      AdminLoad,
      LastLoadModal,
      LoadCheckModal,
      LaddaButton
    },

    computed: {
      ...mapGetters('load', ['haveLoadWithWeighbridge']),

      /**
       * Determine if we can finalise the job.
       *
       * @return boolean
       */
      canFinaliseJob () {
        return this.jobIsNotFinalising && this.jobIsEditable
      },

      canUnfinaliseJob () {
        return this.jobIsFinalising && this.jobIsEditable
      },

      /**
       * Get the loads ordered by the loading date.
       *
       * @return array
       */
      loadsOrderedByLoadingDate () {
        const orderByLoadingDate = load => {
          return moment(load.loading_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }

        return orderBy(this.loads, [orderByLoadingDate, 'id'], ['asc', 'asc'])
      },

      /**
       * Determine if we have no loads.
       *
       * @return boolean
       */
      haveNoLoads () {
        return this.haveJob && this.loads.length === 0
      }
    },

    created () {
      this.getLoads()

      // When the jobs status changes this likely means we have a cancelled job so
      // we need to refetch all the loads.
      this.$watch('job.status', () => (this.getLoads()))
    },

    methods: {
      ...mapActions('job', ['unfinaliseJob']),
      ...mapActions('job/load', ['getLoads']),

      handleUnfinaliseJob () {
        return this.unfinaliseJob(this.job.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AdminLoadList.vue?9e656434